import { GRID_UNIT_PX } from '@/constants';

export default function calcStraightPathByDistance(startCoord, endCoord) {
  const distance = Math.ceil(Math.sqrt(
    (startCoord[0] - endCoord[0]) ** 2
    + (startCoord[1] - endCoord[1]) ** 2,
  ) / GRID_UNIT_PX);

  if (distance <= 2) {
    return [startCoord, endCoord];
  }
  const path = [];
  for (let i = 0; i < distance; i += 1) {
    if (i === 0) {
      path.push(startCoord);
    } else if (i === distance - 1) {
      path.push(endCoord);
    } else {
      path.push([
        startCoord[0] + ((endCoord[0] - startCoord[0]) / distance) * i,
        startCoord[1] + ((endCoord[1] - startCoord[1]) / distance) * i,
      ]);
    }
  }
  return path;
}
